<template>
  <button
    class="button btn--secondary back-button"
    id="go-back"
    @click="goBackClick"
  >
    {{ $t("buttons.back") }}
  </button>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "back-button",
  methods: {
    async goBackClick() {
      if (this.$route.name == "choose-seat-flow") {
        if (this.stage == "seat-preview") {
          await this.seatPreviewBack();
        } else if (this.stage == "choose-tickets") {
          await this.chooseTicketsBack();
        }

        // This handles the actual go back functionality within ChooseSeatFlow
        this.triggerGoBack();
      }

      if (this.$route.name == "delivery-details") {
        // Shopping Cart (and any new views added below) will need some form of disabling loading
        this.updateLoading(true);
        this.$router.push({
          name: "shopping-cart",
          params: { locale: this.$i18n.locale },
        });
      }

      if (
        this.$route.name == "payment" ||
        this.$route.name == "payment-failed"
      ) {
        // Shopping Cart & Delivery details (and any new views added below) will need some form of disabling loading
        this.updateLoading(true);

        if (this.addressRequired) {
          this.$router.push({
            name: "delivery-details",
            params: { locale: this.$i18n.locale },
          });
        } else {
          this.$router.push({
            name: "shopping-cart",
            params: { locale: this.$i18n.locale },
          });
        }
      }

      if (this.$route.name == "registration-details") {
        this.$router.push({
          name: "registration-flow",
          params: {
            locale: this.$i18n.locale,
            event: this.$route.params.event,
          },
        });
      }
    },
    async seatPreviewBack() {
      let inventoryToReturn = [];

      // add every seat inventory ID to a list so they can be returned
      this.bestAvailableOptions.forEach((seatList) => {
        seatList.setsReserved.forEach((seat) => {
          inventoryToReturn.push(seat.inventoryId);
        });
      });

      this.updateInventoryReservedList(inventoryToReturn);

      await this.returnItemsForSelection(this.performance.productId);
    },
    async chooseTicketsBack() {
      // clear errors from previous page (e.g. unsuccessful acrt addition)
      this.clearError();
      this.clearCartAdditionTracking();

      if (this.cart.inventoryIdsReservedList.length > 0) {
        let itemsToReturn = [];

        this.cart.inventoryIdsReservedList.forEach((item) => {
          if (typeof item === "object") {
            itemsToReturn.push(item.inventoryId);
          } else {
            itemsToReturn.push(item);
          }
        });

        await this.updateInventoryReservedList(itemsToReturn);
        await this.returnItemsForSelection(this.performance.productId);
      }
    },
    ...mapActions([
      "triggerGoBack",
      "updateLoading",
      "updateInventoryReservedList",
      "returnItemsForSelection",
      "clearError",
      "clearCartAdditionTracking",
    ]),
  },
  computed: {
    bestAvailableOptions() {
      return this.performance.availableOptions.setsReservedList;
    },
    ...mapGetters(["addressRequired"]),
    ...mapState(["performance", "stage", "cart"]),
  },
};
</script>
